import { makeStyles } from "@material-ui/core/styles";

const createOrEditTeamModalStyles = makeStyles((theme) => ({
  root: {
    width: "600px",
    // height: "87%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 19px 45px 0px #0000001F",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    color: theme.palette.text.primary,
  },

  submitButton: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  cancelButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },

  cardContentInput2: {
    padding: "2px 8px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
  },
}));

export default createOrEditTeamModalStyles;
